"use strict";

exports.__esModule = true;
exports.RenderDataToComponents = void 0;
var _errors = require("../../common/errors");
var _dataset = require("../../entities/dataset");
var _schema = require("../../entities/schema");
var _config = require("../../entities/config");
var _propEntryMaker = require("./prop-entry-maker");
var _makeDatasetMetadataPropEntry = require("./make-dataset-metadata-prop-entry");
var _makeValuePresentation = require("./make-value-presentation");
var _makeBehaviorRelatedProps = require("./make-behavior-related-props");
const RenderDataToComponents = ({
  config,
  formatter,
  dataStore,
  errorReporter,
  dataExpression
}) => ({
  dataset,
  components
}) => {
  const schema = dataStore.readSchema(dataset.collectionId);
  const referencedCollectionIds = _schema.Schema.getReferencedCollectionIds(schema);
  const schemas = dataStore.readSchemas(referencedCollectionIds);
  const recordReadOptions = _dataset.Dataset.getReadOptions(dataset);
  const records = dataStore.readRecords(recordReadOptions);
  const currentRecord = getCurrentRecord(dataset, records);
  const updatedComponents = _config.Config.getUpdatedComponents(config, components);
  for (const component of updatedComponents) {
    const propEntries = mapValuesToComponentProps({
      component,
      dataset,
      schema,
      schemas,
      currentRecord
    }, {
      config,
      formatter,
      dataExpression,
      errorReporter
    });
    if (propEntries.length) {
      try {
        component.setProps(Object.fromEntries(propEntries));
      } catch (error) {
        errorReporter.report(_errors.CoreError.of('Failed setting data to component', {
          cause: error
        }));
      }
    }
  }
};
exports.RenderDataToComponents = RenderDataToComponents;
const mapValuesToComponentProps = (dataContext, dependencies) => {
  const {
    component,
    dataset
  } = dataContext;
  const {
    connection
  } = component;
  const componentProps = [...(0, _makeBehaviorRelatedProps.makeBehaviorRelatedProps)(component, dataset), ...makeDataProps(connection)];
  for (const [propName, propConnection] of Object.entries(connection.properties)) {
    const propEntry = 'datasetMetadataKey' in propConnection ? (0, _makeDatasetMetadataPropEntry.makeDatasetMetadataPropEntry)({
      dataset,
      connection: {
        ...propConnection,
        propName
      }
    }) : (0, _propEntryMaker.propEntryMaker)(({
      valueData: {
        value,
        fieldType
      },
      connection: {
        propName,
        format,
        dataType
      }
    }, dependencies) => [propName, (0, _makeValuePresentation.makeValuePresentation)({
      format,
      dataType,
      fieldType,
      value
    }, dependencies)])({
      ...dataContext,
      connection: {
        ...propConnection,
        propName
      }
    }, dependencies);
    if (propEntry) {
      componentProps.push(propEntry);
    }
  }
  return componentProps;
};
const makeDataProps = connection => {
  const extraProps = [];
  for (const [name, value] of Object.entries(connection.data)) {
    extraProps.push([name, value]);
  }
  return extraProps;
};
const getCurrentRecord = (dataset, records) => {
  const currentRecordIndex = _dataset.Dataset.getCurrentRecordIndex(dataset);
  const currentRecord = records.at(currentRecordIndex);
  return currentRecord;
};
//# sourceMappingURL=render-data-to-components.js.map